import * as React from 'react'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import {Button, Alert} from 'react-bootstrap'
import ApiCall from '../../components/ApiCall/ApiCall'
import Header from '../structure/Header/Header'
import Footer from '../structure/Footer/Footer'
import img_msg from './../../Icone/undraw_message.png'
require('./contact.css')
/*
    this class is the page contact
    user can fulfill input with their email, pseudonyme and a message to our service
*/
interface ContactProps {
}

interface ContactState {
    email: string,
    message: string,
    content: string,
    error: boolean
}

export default class Contact extends React.Component<ContactProps, ContactState> {
    
    private api = new ApiCall()
    constructor(props: ContactProps){
		super(props)
		this.state = {
            email: "",
			message:"",
            content: "",
            error: false
        };
	}


    writeError() {
        let { error, content } = this.state

        if (error === true) {
            return (
                <>
                    <Alert variant="danger">
                        {content}
                    </Alert>
                </>
            );
        } else if (content !== "") {
            return (
                <>
                    <Alert variant="success">
                        {content}
                    </Alert>
                </>
            );
        }
    }

	render() {
		return (
			<>	
				<div id="other_canv">
					<div id="particles-js">
					<Header/>
					<div className="hero-wrap js-fullheight">
						<div className="overlay">
						</div>
							<div id="title-header" className="container">
								<div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true">
                                    <h1 className="mb-3 bread" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
                                        Contacter l'équipe de PrivaSee
                                    </h1>
								</div>
							</div>
						</div>
					</div>
				<section>
					<div className="container">
                        <div id="title-contact">
                            <h3>Vous pouvez nous contacter en nous envoyant une requête ci-dessous</h3>
                            <img alt="msg" src={img_msg} width="40%" height="40%"></img>
                        </div>
                        <br></br>
                        {this.writeError()}
                        <br></br>
                        <div>
                            <b>Pseudonyme</b> <em>(Optionnel)</em>
                            <InputGroup className="mb-3">
                                <FormControl
                                type="Username"
                                placeholder="Votre Pseudonyme"
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                                />
                            </InputGroup>

                            <b>Adresse e-mail</b>
                            <InputGroup className="mb-3">
                                <FormControl
                                type="email"
                                placeholder="Votre adresse mail"
                                aria-label="Recipient's username"
                                aria-describedby="basic-addon2"
                                onChange={this.OnUpdateEmail}
                                value={this.state.email}
                                />
                                <InputGroup.Append>
                                </InputGroup.Append>
                            </InputGroup>
                            <b>Votre requête</b>
                            <InputGroup>
                                <FormControl id="requete-area" type="message" as="textarea" aria-label="With textarea" value={this.state.message} onChange={this.OnUpdateMessage}/>
                            </InputGroup>
                        </div>
                        <br></br>
                        <br></br>
                        <Button variant="success" onClick={this.SbmitRequest}>Envoyer</Button>
					</div>
				</section>
				<Footer/>
				</div>
			</>
		);
	}

    OnUpdateEmail = async (e:any) =>{
        this.setState({
            email: e.target.value
        })
    }

    OnUpdateMessage = async (e:any) =>{
        this.setState({
            message: e.target.value
        })
    }

    SbmitRequest = async () => {
        const request = await this.api.ApiCall("contacts", "POST",
        {
            email: this.state.email,
            message: this.state.message
        })
        if(request.status === 201)
		{
			this.setState({
                error: false,
                content: "Votre message a bien été envoyé à l'équipe de développement. Nous prenons en charge votre requête dans les plus bref délais.",
                email: "",
                message:""
            })
		}
		else {
			this.setState({
                error: true,
                content: "Veuillez entrer une adresse mail afin de pouvoir communiquer avec vous.",
            })
		}
    }
}